import { render, staticRenderFns } from "./EstatusDocumentos.vue?vue&type=template&id=4159e341"
import script from "./EstatusDocumentos.vue?vue&type=script&lang=js"
export * from "./EstatusDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4159e341')) {
      api.createRecord('4159e341', component.options)
    } else {
      api.reload('4159e341', component.options)
    }
    module.hot.accept("./EstatusDocumentos.vue?vue&type=template&id=4159e341", function () {
      api.rerender('4159e341', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificacionesdigital/EstatusDocumentos.vue"
export default component.exports